/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { NegozioTransazioniSelectDTO } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTransazioneVoucherBackofficeListItemDTO } from '../model/models';
import { TransazioneVoucherArticoloErrataCorrigeForm } from '../model/models';
import { TransazioneVoucherBackofficeListFilter } from '../model/models';
import { TransazioneVoucherErrataCorrigeForm } from '../model/models';
import { VoucherArticoloRigaBackofficeDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ErratacorrigeArticoloTransazioneRequestParams {
    idTipoPratica: string;
    transazioneVoucherArticoloErrataCorrigeForm: TransazioneVoucherArticoloErrataCorrigeForm;
}

export interface ErratacorrigeTransazioneRequestParams {
    idTipoPratica: string;
    transazioneVoucherErrataCorrigeForm: TransazioneVoucherErrataCorrigeForm;
}

export interface ListArticoliVoucherBackofficeRequestParams {
    idTipoPratica: string;
    codice: string;
}

export interface ListNegoziTransazioniBackofficeRequestParams {
    idTipoPratica: string;
}

export interface ListTransazioniBackofficeRequestParams {
    idTipoPratica: string;
    filter: TransazioneVoucherBackofficeListFilter;
    pageable: Pageable;
}


export interface GestioneErrataCorrigeTransazioniVoucherServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Errata-corrige di un consumo articolo (voucher cedole).
     * Annulla la transazione articolo originale (PRENOTAZIONE/REGOLARE), riporta l\&#39;istanza articolo allo stato precedente e riapre il voucher SEMPRE a DA_CONSUMARE (mai CONSUMATO→PARZIALMENTE_CONSUMATO). Richiede la version dell\&#39;istanza articolo. SUPERADMIN/OP_COMUNE scopati al comune del bando.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/transazioni/articolo-erratacorrige
* @param requestParameters
     */
    erratacorrigeArticoloTransazione(requestParameters: ErratacorrigeArticoloTransazioneRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Errata-corrige di una transazione voucher.
     * Annulla la transazione originale (obbligatoria), ripristina il residuo del voucher (invariante ≤ valore totale), riporta il voucher a DA_CONSUMARE e crea la nuova ERRATA_CORRIGE (valore &#x3D; valore scontrino cappato al residuo). Richiede la version del voucher. SUPERADMIN/OP_COMUNE scopati al comune del bando.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/transazioni/erratacorrige
* @param requestParameters
     */
    erratacorrigeTransazione(requestParameters: ErratacorrigeTransazioneRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Elenca gli articoli di un voucher cedole (input dell\&#39;errata-corrige articolo).
     * Riga-per-libro di un voucher cedole: id_articolo_pratica, version_articolo (la @Version dell\&#39;istanza ArticoloPratica, distinta da version_voucher), titolo, valore, stato e id_transazione (ultima transazione di consumo attiva correlata all\&#39;istanza) — gli input del form articolo-erratacorrige senza un GET aggiuntivo. Scope per-comune via checkTipoPratica (SUPERADMIN bypassa, OP_COMUNE fuori-comune → 403); codice fuori dal bando → lista vuota. id_transazione è null per i libri consumati prima dell\&#39;introduzione della correlazione (dialog degradato).
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/transazioni/voucher/{codice}/articoli
* @param requestParameters
     */
    listArticoliVoucherBackoffice(requestParameters: ListArticoliVoucherBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Array<VoucherArticoloRigaBackofficeDTO>>;

    /**
     * Elenca i negozi che hanno transato sul bando (tendina del filtro).
     * Voci della tendina \&#39;negozio\&#39; nel filtro della lista transazioni: solo i negozi che hanno EFFETTIVAMENTE transato sul bando, non tutti quelli abilitati (una tendina che offre opzioni da cui non esce nessuna riga fa sembrare rotto il filtro). Include i negozi con sole righe annullate: quelle righe restano in lista, ed e\&#39; proprio chi cerca una correzione ad averne bisogno. Stesso gate e stesso scope della lista (checkTipoPratica: SUPERADMIN bypassa, OP_COMUNE fuori-comune -&gt; 403). Non paginato.
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/transazioni/negozi
* @param requestParameters
     */
    listNegoziTransazioniBackoffice(requestParameters: ListNegoziTransazioniBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Array<NegozioTransazioniSelectDTO>>;

    /**
     * Elenca le transazioni voucher di un bando (input dell\&#39;errata-corrige).
     * Page delle transazioni del bando (scope per-comune via checkTipoPratica: SUPERADMIN bypassa, OP_COMUNE fuori-comune → 403), filtrabile per id_pratica e/o codice_voucher. Ogni riga porta id_transazione, codice_voucher, intestatario, nome_negozio e version_voucher — quest\&#39;ultima da rispedire nel form errata-corrige senza un GET di dettaglio aggiuntivo. Ordinamento default per data DESC.
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/transazioni
* @param requestParameters
     */
    listTransazioniBackoffice(requestParameters: ListTransazioniBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTransazioneVoucherBackofficeListItemDTO>;

}
